import src from "IMAGE";
export default { src, width: 640, height: 96, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAkeFwQKHBYICRQQBQghGQwRNysUK0o4FAkXEgUAAAAAKlIChhMb7Z4AAAAASUVORK5CYII="};
